import { Injectable } from '@angular/core';
import { environment } from "../../environments/environment";
import { CustomHttpClientService } from './custom-http-client.service';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class MaintananceService {

  url = environment.apiUrl;
  constructor(private http: CustomHttpClientService) {}

  createMaintanance(value: any, userId: string): Observable<any> {
    const Data = JSON.stringify(value);
    const formData: FormData = new FormData();
    formData.append('id', userId);
    formData.append('feedData', Data);
    formData.append('eventImage', value.file || null);

    return this.http.post<any>(`${this.url}maintanance/createMaintanance`, formData)
        .pipe(
          catchError((error: any) => throwError(error))
        );
}

  getMaintanance(id: any):Observable<any>{
    return this.http.get<any>(`${this.url}maintanance/getMaintanance/${id}`);
  }

  getAllMaintenance(id: any):Observable<any>{
    return this.http.get<any>(`${this.url}maintanance/getAllMaintenance/${id}`);
  }

  deleteMaintanance(id: string): Observable<any> {
    return this.http.delete<any>(`${this.url}maintanance/deleteMaintanance/${id}`)
  }

  updateMaintananceStatus(status: any, id: any): Observable<any> {
    let formData:FormData = new FormData;
    formData.append('id', id);
    formData.append('status', status);
    return this.http.put<any>(`${this.url}maintanance/maintananceStatus`,formData);
  }
  maintananceLikes(id, userId){
     let formData:FormData = new FormData;
     formData.append('mainId', id);
     formData.append('userId', userId);
     return this.http.post<any>(`${this.url}maintanance/addUpvote`, formData);
  }

  getMaintananceById(id: string, action: boolean | null = null): Observable<any> {
    let actionParam = action === false ? 'false' : null;
    const params = `?id=${id}&action=${actionParam}`;
    
    return this.http.get<any>(`${this.url}maintanance/getMaintananceById/${params}`);
}

updateMaintanance(value: any, id: string, state: string): Observable<any> {
  const Data = JSON.stringify(value);
  const formData: FormData = new FormData();
  formData.append('value', Data);
  formData.append('id', id);
  formData.append('changed', state);
  formData.append('eventImage', value.file || null);

  return this.http.put<any>(`${this.url}maintanance/updatePost`, formData);
}
}
